export const GMAT_SET_CATALOG = "GMAT_SET_CATALOG";
export const GMAT_SET_LOAD_ERROR = "GMAT_SET_LOAD_ERROR";
export const GMAT_CATALOG_REQUESTED = "GMAT_CATALOG_REQUESTED";
export const GMAT_SET_ATTEMPT_STARTING = "GMAT_SET_ATTEMPT_STARTING";
